import { createStore } from 'zustand/vanilla';
import { type AgentCanvasStore, createAgentCanvasSlice } from './slices/agent-canvas';
import { type AgentChatTabsStore, createAgentChatTabsSlice } from './slices/agent-chat-tabs';
import { type AgentProjectStore, createAgentProjectSlice } from './slices/agent-project';
import { type ClawStore, createClawStore } from './slices/claw';
import { type CreationDetailStore, createCreationDetailSlice } from './slices/creation-detail';
import { createFeedDetailConfigSlice, type FeedDetailConfigStore } from './slices/feed-detail-config';
import { createFlySlice, type FlyStore } from './slices/fly';
import { createGlobalModalSlice, type GlobalModalStore } from './slices/global-modal';
import { createLiveSlice, type LiveStore } from './slices/live';
import { createPaySlice, type PayStore } from './slices/pay';
import { createReferenceModalSlice, type ReferenceModalStore } from './slices/reference-modal';
import { createTaskFormSlice, type TaskFormStore } from './slices/task-form';
import { createTaskListSlice, type TaskListStore } from './slices/task-list';
import { createToolsFormSlice, type ToolsFormStore } from './slices/tools-form';
import { createTourQueueSlice, type TourQueueStore } from './slices/tour-queue';
import { createUserInfoSlice, type UserInfoStore } from './slices/user-info';

export type ViduStore = TaskFormStore &
  ToolsFormStore &
  UserInfoStore &
  ReferenceModalStore &
  CreationDetailStore &
  GlobalModalStore &
  TaskListStore &
  PayStore &
  FlyStore &
  FeedDetailConfigStore &
  TourQueueStore &
  AgentChatTabsStore &
  AgentProjectStore &
  AgentCanvasStore &
  ClawStore &
  LiveStore;

export const createViduStore = () => {
  return createStore<ViduStore>()((set, get, store) => ({
    ...createTaskFormSlice(set, get, store),
    ...createToolsFormSlice(set, get, store),
    ...createTaskListSlice(set, get, store),
    ...createUserInfoSlice(set, get, store),
    ...createReferenceModalSlice(set, get, store),
    ...createCreationDetailSlice(set, get, store),
    ...createGlobalModalSlice(set, get, store),
    ...createPaySlice(set, get, store),
    ...createFlySlice(set, get, store),
    ...createFeedDetailConfigSlice(set, get, store),
    ...createTourQueueSlice(set, get, store),
    ...createAgentChatTabsSlice(set, get, store),
    ...createAgentProjectSlice(set, get, store),
    ...createAgentCanvasSlice(set, get, store),
    ...createClawStore(set, get, store),
    ...createLiveSlice(set, get, store),
  }));
};
